/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiflowinputnote3Inputs */

const en_aiflowinputnote3 = /** @type {(inputs: Aiflowinputnote3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Or write what you have in mind`)
};

const de_aiflowinputnote3 = /** @type {(inputs: Aiflowinputnote3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oder schreib, was du dir vorstellst`)
};

/**
* | output |
* | --- |
* | "Or write what you have in mind" |
*
* @param {Aiflowinputnote3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowinputnote3 = /** @type {((inputs?: Aiflowinputnote3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowinputnote3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowinputnote3(inputs)
	return de_aiflowinputnote3(inputs)
});
export { aiflowinputnote3 as "aiFlowInputNote" }